import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

const easyPaySeoMetaData: SeoMetaData[] = [
  {
    path: '/premiums/easy-pay',
    seo: {
      en: {
        title: 'My Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: 'Mi Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/error',
    seo: {
      en: {
        title: 'My Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: 'Mi Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/signup',
    seo: {
      en: {
        title: 'Sign up for Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: 'Inscríbase en el Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/signup/submitted',
    seo: {
      en: {
        title: 'Medicare Easy Pay request submitted | Medicare',
        description: ''
      },
      es: {
        title: 'Solicitud del Pago Fácil de Medicare enviada | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/edit',
    seo: {
      en: {
        title: 'Change Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: 'Cambiar el Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/edit/submitted',
    seo: {
      en: {
        title: 'Medicare Easy Pay change submitted | Medicare',
        description: ''
      },
      es: {
        title: 'Cambio del Pago Fácil de Medicare enviada | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/easy-pay/stop',
    seo: {
      en: {
        title: 'Stop Medicare Easy Pay | Medicare',
        description: ''
      },
      es: {
        title: 'Cancelar el Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums-easy-pay/stop/success',
    seo: {
      en: {
        title: 'Medicare Easy Pay stopped | Medicare',
        description: ''
      },
      es: {
        title: 'Se suspendió el Pago Fácil de Medicare | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  component: Component.EasyPay,
  ...seoMetaData
}))

const nonEasyPaySeoMetaData: SeoMetaData[] = [
  {
    path: '/premiums/bills',
    seo: {
      en: {
        title: 'Premium bills | Medicare',
        description: ''
      },
      es: {
        title: 'Factura de la prima | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/monthly',
    seo: {
      en: {
        title: 'My monthly premiums | Medicare',
        description: ''
      },
      es: {
        title: 'Mis primas mensuales | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/dashboard',
    seo: {
      en: {
        title: 'My premiums | Medicare',
        description: ''
      },
      es: {
        title: 'Mis primas | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/history',
    seo: {
      en: {
        title: 'Payment history | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  },
  {
    path: '/premiums/make-a-payment',
    seo: {
      en: {
        title: 'Make a payment | Medicare',
        description: ''
      },
      es: {
        title: 'Hacer un pago | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/make-a-payment/processing',
    seo: {
      en: {
        title: 'Submitting payment | Medicare',
        description: ''
      },
      es: {
        title: 'Enviar pago | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/make-a-payment/success',
    seo: {
      en: {
        title: 'Payment successful | Medicare',
        description: ''
      },
      es: {
        title: 'Pago exitoso | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/make-a-payment/submitted',
    seo: {
      en: {
        title: 'Payment submitted | Medicare',
        description: ''
      },
      es: {
        title: 'Pago enviado | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/premiums/make-a-payment/error',
    seo: {
      en: {
        title: 'Issue with your payment | Medicare',
        description: ''
      },
      es: {
        title: 'Problemas con su pago | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  component: Component.Premiums,
  ...seoMetaData
}))

export const premiumsSeoMetaData: SeoMetaData[] = [
  ...nonEasyPaySeoMetaData,
  ...easyPaySeoMetaData
]
